const getGoogleClientId = () => {
  let googleAnalytics = document.cookie.match('(?:^|;)\\s*_ga=([^;]*)');
  const decodedGoogleClientId = googleAnalytics
    ? decodeURIComponent(googleAnalytics[1])
    : null;
  if (decodedGoogleClientId) {
    googleAnalytics = decodedGoogleClientId.match(/(\d+\.\d+)$/);
  }
  return googleAnalytics ? googleAnalytics[1] : null;
};

export default getGoogleClientId;
